import _extends from '@babel/runtime/helpers/esm/extends';
import React, { forwardRef } from 'react';
import { Avatar, AvatarBadge as AvatarBadge$1, AvatarGroup as AvatarGroup$1 } from '@chakra-ui/react';
import { BoxIcon } from '@outdoorly/icons';

/**
 * An avatar for a brand or other non-user entity of Outdoorly
 */
// eslint-disable-next-line react/display-name
var EntityAvatar = /*#__PURE__*/forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    ref: ref,
    variant: "entity",
    borderRadius: borderRadiusSize[props.size || 'md'] || 'lg',
    backgroundColor: "scheme.bgSecondary",
    icon: /*#__PURE__*/React.createElement(BoxIcon, {
      color: "scheme.textPrimary"
    })
  }, props));
});
var borderRadiusSize = {
  '2xs': '0.25rem',
  xs: '0.3125rem',
  sm: '0.375rem',
  md: '0.5rem',
  lg: '0.625rem',
  xl: '0.8126rem',
  '2xl': '1rem'
};

/**
 * An avatar for a user of Outdoorly
 */

var UserAvatar = function UserAvatar(props) {
  return /*#__PURE__*/React.createElement(Avatar, _extends({
    variant: "user"
  }, props));
};
var AvatarBadge = function AvatarBadge(props) {
  return /*#__PURE__*/React.createElement(AvatarBadge$1, _extends({
    borderColor: "scheme.border"
  }, props));
};
var AvatarGroup = function AvatarGroup(props) {
  return /*#__PURE__*/React.createElement(AvatarGroup$1, _extends({
    borderColor: "scheme.border"
  }, props));
};

export { AvatarBadge, AvatarGroup, EntityAvatar, UserAvatar };
